import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { getUpdateOrganizationPhotoState } from 'data/organizations/selectors'
import {
  updateOrganization as updateOrganizationAction,
  updateOrganizationPhoto as updateOrganizationPhotoAction,
  updateOrganizationDomain as updateOrganizationDomainAction,
} from 'data/organizations/actions'

import Layout from './Layout'
import useOrganizationField from '../hooks/useOrganizationField'
import useDomainAvailability from '../hooks/useDomainAvailability'

export default function SettingsOrganizationInformations() {
  const organizationName = useOrganizationField('name')
  const organizationPhotoURL = useOrganizationField('photoURL')
  const organizationPhotoState = useSelector(getUpdateOrganizationPhotoState)
  const organizationDomain = useOrganizationField('domain')

  const dispatch = useDispatch()
  const updateOrganization = React.useCallback(
    params => dispatch(updateOrganizationAction(params)),
    [dispatch]
  )
  const updateOrganizationDomain = React.useCallback(
    domain => dispatch(updateOrganizationDomainAction(domain)),
    [dispatch]
  )
  const updateOrganizationPhoto = React.useCallback(
    ({ photoFile }) => dispatch(updateOrganizationPhotoAction({ photoFile })),
    [dispatch]
  )

  return (
    <Layout
      organizationName={organizationName}
      organizationDomain={organizationDomain}
      organizationPhotoURL={organizationPhotoURL}
      organizationPhotoState={organizationPhotoState}
      updateOrganization={updateOrganization}
      updateOrganizationPhoto={updateOrganizationPhoto}
      updateOrganizationDomain={updateOrganizationDomain}
      useDomainAvailability={useDomainAvailability}
    />
  )
}
